export const GET_ORDER_NOTIFICATION_HISTORY = "GET_ORDER_NOTIFICATION_HISTORY";
export const GET_ORDER_NOTIFICATION_HISTORY_SUCCESS = "GET_ORDER_NOTIFICATION_HISTORY_SUCCESS";
export const GET_ORDER_NOTIFICATION_HISTORY_FAIL = "const GET_ORDER_NOTIFICATION_HISTORY_FAIL";